import React from "react";
import { Card, Input, notification, Form, Switch, Button, Select } from "antd";
import NumberFormat from "react-number-format";
import { useMutation } from "@apollo/react-hooks";
import { userGql } from "../../../graphql/user";
import { ApolloError } from "apollo-boost";
import { AsyncValid } from "../../../common/AsyncValid";
import { defaultFormLayout } from "../../../common/Utils";
import { observer } from "mobx-react";
import { Store } from "../../../store/Store";
import { Titles } from "../../../common/Fr";

export const AddUserPanel = observer(({ orgId, onClose }) => {
  const [form] = Form.useForm();
  const store = Store.orgsStore.orgView.addUserStore;
  const [createFamily, { loading: saving }] = useMutation(userGql.createFamily);

  const save = () => {
    form.validateFields().then((values) => {
      const { mobile, ...other } = values;

      createFamily({
        variables: {
          input: { mobile: mobile?.replace(/[ \-()]/g, ""), orgId, role: ["Parent"], ...other },
        },
      })
        .then((res) => {
          notification.success({
            message: `User ${values.firstName} created.`,
          });
          onClose(true);
        })
        .catch((err: ApolloError) => {
          if (err.graphQLErrors) {
            try {
              const json = JSON.parse(err.graphQLErrors[0].message);
              if (json.msg === "Duplicate email") {
                form.setFields([
                  {
                    name: "email",
                    errors: [
                      `User with the same email address was found: ${json.info} Division. If the user has moved, please contact the Managing Director to move the record to your division. Otherwise, please double check the email.`,
                    ],
                  },
                ]);
              }
            } catch {
              notification.error({
                message: err.graphQLErrors[0].message,
              });
            }
          }
        });
    });
  };

  const onValuesChange = (values) => {};

  return (
    <Card size="small">
      <Form form={form} {...defaultFormLayout} initialValues={{ role: ["Parent"] }} onValuesChange={onValuesChange}>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "New user's email address is missing." },
            { type: "email", message: "Erroneous email address format." },
          ]}
        >
          <Input placeholder="Enter email" />
        </Form.Item>
        <Form.Item label="First Name" name="firstName" rules={[{ required: true, message: "Please input first name" }]}>
          <Input maxLength={50} placeholder="Enter first name" />
        </Form.Item>
        <Form.Item label="Last Name" name="lastName" rules={[{ required: true, message: "Please input last name" }]}>
          <Input maxLength={50} placeholder="Enter last name" />
        </Form.Item>
        <Form.Item label="Salutation" name="title">
          <Select placeholder="Select salutation" allowClear>
            {Titles.map((x) => (
              <Select.Option value={x} key={x}>
                {x}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Mobile Number" name="mobile" rules={[AsyncValid.mobile]}>
          <NumberFormat format="+1 (###) ###-####" mask="_" className="ant-input" />
        </Form.Item>
        <Form.Item label="Is Community Leader" valuePropName="checked" name="isLeader">
          <Switch />
        </Form.Item>

        <h3>Child Info.</h3>

        <Form.Item
          label="Child First Name"
          name="childFirstName"
          rules={[{ required: true, message: "Please input first name" }]}
        >
          <Input maxLength={50} placeholder="Enter first name" />
        </Form.Item>

        <Form.Item label="Grade" name="grade" rules={[{ message: "Please select grade" }]}>
          <Select placeholder="Enter grade">
            {store.orgStore.org?.grades?.map((x) => (
              <Select.Option value={x} key={x}>
                {x}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }} style={{ textAlign: "right" }}>
          <Button loading={saving} type="primary" onClick={save}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
});
